import { uuid } from "../uuid";

export const roomPid = uuid;
export const nullableRoomPid = {
  ...roomPid,
  nullable: true
};
